module.exports = __webpack_public_path__ + "media/images/review/star_5-515597be62386955cb932d14cd83c30f.svg";